import { Injectable } from '@angular/core';
import Map from 'ol/Map.js';
import { defaults as defaultInteractions } from 'olgm/interaction.js';
import { transform, fromLonLat } from 'ol/proj.js';
import GoogleLayer from 'olgm/layer/Google.js';
import TileLayer from 'ol/layer/Tile.js';
import View from 'ol/View.js';
import OLGoogleMaps from 'olgm/OLGoogleMaps.js';
import OSMSource from 'ol/source/OSM.js';
import Feature from 'ol/Feature.js';
import Style from 'ol/style/Style.js';
import VectorLayer from 'ol/layer/Vector.js';
import VectorSource from 'ol/source/Vector.js';
import Point from 'ol/geom/Point.js';
import Icon from 'ol/style/Icon.js';
import { defaults as defaultControls, ScaleLine, FullScreen } from 'ol/control';


@Injectable({
	providedIn: 'root'
})

export class MapaMarkerService {
	public map: Map;
	public olGM: OLGoogleMaps;
	public googleLayer = new GoogleLayer();
	public osmLayer: TileLayer;
	public center = [-101.3770056, 23.8636449];

	public iconoMarcadorFeature: Feature
	public iconoMarcadorStyle: Style;
	public vectorMarcadorSource: VectorSource;
	public vectorMarcadorLayer: VectorLayer;


	constructor() { }

	public inicializarMapa = () => {
		this.osmLayer = new TileLayer({
			source: new OSMSource(),
			visible: false
		});

		this.vectorMarcadorSource = new VectorSource({});
		this.vectorMarcadorLayer = new VectorLayer({
			source: this.vectorMarcadorSource,
			updateWhileAnimating: true,
			updateWhileInteracting: true,
		});

		this.map = new Map({
			// use las interacciones predeterminadas recomendadas de OL3-Google-Maps
			interactions: defaultInteractions(),
			layers: [
				this.googleLayer,
				this.vectorMarcadorLayer
			],
			overlays: [
			],
			target: 'map-marker',
			view: new View({
				center: fromLonLat(this.center),
				zoom: 16,
			}),
			controls: defaultControls({ attribution: true, zoom: true }).extend([
				new ScaleLine(),
				new FullScreen()
			])
		});
		this.olGM = new OLGoogleMaps({
			map: this.map,
			mapIconOptions: {
				useCanvas: true
			},
			gmapOptions: {
				streetViewControl: true,

			},
			watch: {
				'vector': false
			}
		});
		this.olGM.activate();
		this.map.updateSize();
	}

	public pintarMarcadores = (producto) => {
		this.vectorMarcadorSource.clear();
		const coordinate = [producto.lng, producto.lat];

		this.iconoMarcadorFeature = new Feature({
			type: 'marker',
			idActivo: producto.imei,
			data: producto,
			dataTooltip: `div${producto.imei}`,
			geometry: new Point(transform(coordinate, 'EPSG:4326', 'EPSG:3857'))
		});

		this.iconoMarcadorStyle = new Style({
			image: new Icon({
				anchor: [0.5, 0.5],
				anchorXUnits: 'fraction',
				anchorYUnits: 'fraction',
				src: './assets/media/marcadores/MarkerReportesRojo.png'
			}),
			zIndex: 10
		});

		this.iconoMarcadorFeature.setStyle(this.iconoMarcadorStyle);
		this.vectorMarcadorSource.addFeature(this.iconoMarcadorFeature);
		this.vectorMarcadorLayer.setVisible(true);
		this.map.getView().setCenter(fromLonLat([producto.lng, producto.lat]));
	}

}
